"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var compiler_1 = __importDefault(require("./compiler"));

var determineInput_1 = require("./converters/determineInput");

var rgbToHSL_1 = require("./converters/rgbToHSL");

var hexToHSL_1 = __importDefault(require("./converters/hexToHSL"));

var hslToRGB_1 = __importDefault(require("./converters/hslToRGB"));

var hslToHex_1 = __importDefault(require("./converters/hslToHex"));

var toStringFunctions_1 = require("./converters/toStringFunctions");

var ColourChisel =
/** @class */
function () {
  function ColourChisel(input) {
    this.discriminator = "isColourChisel";

    switch (determineInput_1.determineInput(input)) {
      case determineInput_1.InputType.RGB:
        this.path = [rgbToHSL_1.rgbStringToHSL(input)];
        break;

      case determineInput_1.InputType.HSL:
        this.path = [input];
        break;

      case determineInput_1.InputType.HEX:
        this.path = [hexToHSL_1["default"](input)];
        break;

      case determineInput_1.InputType.COLOUR_CHISEL:
        this.path = input.hsl();
        break;

      case determineInput_1.InputType.CODE:
        this.path = ColourChisel.compile(input)[0].hsl();
        break;

      case determineInput_1.InputType.ARRAY:
        this.path = input.map(function (i) {
          var type = determineInput_1.determineInput(i);

          if ([determineInput_1.InputType.ARRAY, determineInput_1.InputType.CODE].includes(type)) {
            throw new Error("Incompatible input in array: " + i);
          }

          return new ColourChisel(i).hsl()[0];
        });
        break;

      default:
        this.path = [];
    }
  }

  ColourChisel.prototype.addToPath = function (input) {
    var temp = new ColourChisel(input);
    return new ColourChisel(__spreadArrays(this.hsl(), temp.hsl()));
  };

  ColourChisel.prototype.analogous = function (range) {
    if (range === void 0) {
      range = 45;
    }

    return this.rotate(range);
  };

  ColourChisel.prototype.compliment = function () {
    return this.rotate(180);
  };

  ColourChisel.prototype.hex = function () {
    return this.path.map(hslToHex_1["default"]);
  };

  ColourChisel.prototype.rgb = function () {
    return this.path.map(hslToRGB_1["default"]);
  };

  ColourChisel.prototype.hsl = function () {
    // done to make caller safe
    return this.path.map(function (hsl) {
      return __spreadArrays(hsl);
    });
  };

  ColourChisel.prototype.rotate = function (range) {
    var newPath = this.hsl().map(function (hsl) {
      return [hsl[0] + range, hsl[1], hsl[2]];
    });
    return new ColourChisel(newPath);
  };

  ColourChisel.prototype.scale = function (amount) {
    var newPath = this.hsl().map(function (hsl) {
      return [hsl[0], hsl[1] * amount, hsl[2]];
    });
    return new ColourChisel(newPath);
  };

  ColourChisel.prototype.clone = function () {
    return new ColourChisel(this.hsl());
  };

  ColourChisel.prototype.js = function (options) {
    var vals = this.getVals(options);
    var prefix = options.variablePrefix ? options.variablePrefix : "val";
    var file = "// This file was generated using colour-chisel\n";
    file += "// https://github.com/Metroxe/colour-chisel\n\n";
    vals.forEach(function (v, i) {
      return file += "export const " + prefix + i + " = \"" + v + "\";\n";
    });
    return file;
  };

  ColourChisel.prototype.scss = function (options) {
    var vals = this.getVals(options);
    var prefix = options.variablePrefix ? options.variablePrefix : "val";
    var file = "// This file was generated using colour-chisel\n";
    file += "// https://github.com/Metroxe/colour-chisel\n\n";
    vals.forEach(function (v, i) {
      return file += "$" + prefix + i + " = " + v + ";\n";
    });
    return file;
  };

  ColourChisel.prototype.getVals = function (_a) {
    var format = _a.format,
        ignoreCurrent = _a.ignoreCurrent,
        appendedColourChisels = _a.appendedColourChisels;
    var ccs = [];

    if (!ignoreCurrent) {
      ccs = [this];
    }

    if (appendedColourChisels) {
      ccs = __spreadArrays(ccs, appendedColourChisels);
    }

    var ret = [];
    ccs.forEach(function (cc) {
      switch (format) {
        case "rgb":
          ret = __spreadArrays(ret, cc.rgb().map(toStringFunctions_1.rgbToString));
          break;

        case "hsl":
          ret = __spreadArrays(ret, cc.rgb().map(toStringFunctions_1.hslToString));
          break;

        default:
          ret = __spreadArrays(ret, cc.hex());
      }
    });
    return ret;
  };

  ColourChisel.compile = compiler_1["default"];
  return ColourChisel;
}();

exports["default"] = ColourChisel;